import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Euro, Send, CreditCard } from "lucide-react";
import { toast } from "sonner";
import { offersAPI } from "../lib/api";

export default function OfferModal({ open, onClose, listing }) {
  const [amount, setAmount] = useState("");
  const [message, setMessage] = useState("");
  const [withPayment, setWithPayment] = useState(false);
  const [loading, setLoading] = useState(false);

  const quickAmounts = [
    Math.round(listing.price * 0.7),
    Math.round(listing.price * 0.8),
    Math.round(listing.price * 0.9)
  ];

  const submit = async () => {
    if (!amount || Number(amount) <= 0) {
      toast.error("Inserisci un'offerta valida");
      return;
    }
    setLoading(true);
    try {
      await offersAPI.create(listing.id, { amount: Number(amount), message, with_payment: withPayment });
      toast.success(`Offerta di €${amount} inviata al venditore!`, {
        description: withPayment ? "Pagamento tramite Stripe al momento dell'accettazione" : "Attendi risposta entro 24h"
      });
      setAmount(""); setMessage(""); setWithPayment(false);
      onClose();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Errore invio offerta");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Euro className="w-5 h-5 text-[#1d3d3a]" />Fai un'offerta</DialogTitle>
          <DialogDescription>Prezzo richiesto: <span className="font-bold text-slate-900">€ {Number(listing.price).toLocaleString("it-IT")}</span></DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div>
            <label className="text-xs font-bold text-slate-700 block mb-2">La tua offerta</label>
            <div className="relative">
              <Euro className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <Input type="number" value={amount} onChange={(e) => setAmount(e.target.value)} placeholder="0" className="pl-9 h-12 text-lg font-bold"/>
            </div>
            <div className="flex gap-2 mt-2">
              {quickAmounts.map(q => (
                <button key={q} onClick={() => setAmount(String(q))} className="flex-1 text-xs py-1.5 px-2 border border-slate-200 rounded-lg hover:border-[#1d3d3a] hover:bg-slate-50">
                  € {q}
                </button>
              ))}
            </div>
          </div>

          <div>
            <label className="text-xs font-bold text-slate-700 block mb-2">Messaggio (opzionale)</label>
            <Textarea value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Es: Posso ritirare a Serravalle anche domani" rows={3} />
          </div>

          <label className="flex items-start gap-3 p-3 border-2 border-slate-200 rounded-xl cursor-pointer hover:border-[#1d3d3a] transition-colors">
            <input type="checkbox" checked={withPayment} onChange={(e) => setWithPayment(e.target.checked)} className="mt-1 accent-[#1d3d3a]" />
            <div>
              <div className="flex items-center gap-1.5 text-sm font-bold text-slate-900">
                <CreditCard className="w-4 h-4 text-[#1d3d3a]"/> Pagamento protetto Stripe
              </div>
              <div className="text-xs text-slate-500 mt-0.5">I fondi vengono trattenuti e rilasciati al venditore solo dopo la consegna.</div>
            </div>
          </label>
        </div>

        <div className="flex gap-2 mt-2">
          <Button variant="outline" onClick={onClose} className="flex-1">Annulla</Button>
          <Button onClick={submit} disabled={loading} className="flex-1 bg-[#1d3d3a] hover:bg-[#102624]">
            <Send className="w-4 h-4 mr-2"/>{loading ? "Invio..." : "Invia offerta"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
